module["exports"] = [
  "North",
  "East",
  "West",
  "South",
  "New",
  "Lake",
  "Port"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/city_prefix.js
// module id = 234
// module chunks = 0